import React from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Box, Modal, Typography } from "@mui/material";

interface CustomModalProps {
	open: boolean;
	onClose: () => void;
	title?: string;
	children: React.ReactNode;
	showCloseButton?: boolean;
}

const CustomModal: React.FC<CustomModalProps> = ({ open, onClose, title, children, showCloseButton = true }) => {
	return (
		<Modal
			open={open}
			onClose={onClose}
			aria-labelledby="modal-modal-title"
			aria-describedby="modal-modal-description"
			sx={{
				display: "flex",
				alignItems: "center", // Centers the modal vertically
				justifyContent: "center" // Centers the modal horizontally
			}}
		>
			<Box
				sx={{
					bgcolor: "background.paper",
					boxShadow: 24,
					p: 3,
					borderRadius: 2,
					width: "60%", // Adjust width as needed
					maxWidth: "60%", // Prevents too wide modals
					maxHeight: "90vh", // Ensures the modal doesn't exceed viewport height
					overflowY: "auto" // Enables scrolling for overflowing content
				}}
			>
				{title && (
					<Typography id="modal-modal-title" variant="h6" component="h2" style={{ marginLeft: "10px" }}>
						{title}
					</Typography>
				)}

				<Box id="modal-modal-content">{children}</Box>

				{showCloseButton && (
					<DialogActions sx={{ justifyContent: "flex-end", mt: 2 }}>
						<Button
							onClick={onClose}
							sx={{
								backgroundColor: "#bdbdbd",
								color: "black",
								"&:hover": { backgroundColor: "#9e9e9e" } // Optional hover effect
							}}
						>
							Close
						</Button>
					</DialogActions>
				)}
			</Box>
		</Modal>
	);
};

export default CustomModal;
